import React from "react";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import Navigation from "../Navigation/Navigation";
import { Link, NavLink } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useState } from "react";
import { useEffect } from "react";
import MyProfileSubscription from "../MyProfileSubscription/MyProfileSubscription";
import { getBusinessSwitched } from "../../Utils/LocalStorage";

const MyProfileSubscriptionPage = () => {
  const [currentTab, setcurrentTab] = useState("");
  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    if (endPath[4] === "subscription") {
      setcurrentTab("subscription");
    }
  }, []);
  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/dashboard"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">My Profile</p>
          {/* {CheckChargebeeSubscriptionFlag && (
            <p className="app_locked_info_text">
              (Your account has been suspended as the grace period has ended.
              Please renew your plan to reactivate your account.)
            </p>
          )} */}

          <div className="acc-dashboard mt-4">
            <div className="mb-2 tabs_ul">
              <NavLink to={"/my-profile/general-info"} className={"tabs_li"}>
                General Info
              </NavLink>
              <NavLink to={"/my-profile/business-info"} className={"tabs_li"}>
                Business Info
              </NavLink>
              <NavLink to={"/my-profile/store-info"} className={"tabs_li"}>
                Store Info
              </NavLink>
              <NavLink
                to={"/my-profile/subscription"}
                className={
                  currentTab === "subscription" ? " activeTab" : "tabs_li"
                }
              >
                Subscription
              </NavLink>
              {/* <NavLink to={"/my-profile/bank-info"} className={"tabs_li"}>
                Bank Info
              </NavLink> */}
              {/* <NavLink
                to={"/my-profile/transaction-history"}
                className={"tabs_li"}
              >
                Transaction History
              </NavLink> */}
              <NavLink
                to={"/my-profile/marketplace-membership"}
                className={"tabs_li"}
              >
                Marketplace Membership
              </NavLink>
              {getBusinessSwitched() === "false" && (
                <NavLink to="/my-profile/manage-business" className={"tabs_li"}>
                  Manage Businesses
                </NavLink>
              )}
            </div>
            <div className="mt-3">
              <MyProfileSubscription />
            </div>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default MyProfileSubscriptionPage;
